import React, { useState } from 'react';
import { Button } from '@alifd/next';
import { EditServiceProps } from './types';
import ServiceDialog from './components/ServiceDialog';

const EditService: React.FC<EditServiceProps> = ({ buttonProps }) => {
  const [showDialog, setShowDialog] = useState(false);
  return (
    <>
      <Button {...(buttonProps || {})} onClick={() => setShowDialog(true)}>
        編輯服務類型
      </Button>
      <ServiceDialog showDialog={showDialog} setShowDialog={setShowDialog} />
    </>
  );
};

export default EditService;
